function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "organization_avatar",
  transform: "translate(5.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.88888889,1 L6.88888889,7.66666667 L1,7.66666667 C0.444444444,7.66666667 0,8.11111111 0,8.66666667 L0,21 L6.88888889,21 L9.44444444,21 L18,21 L18,15.3333333 C18.1111111,15.2222222 18.6666667,14.6666667 19.5555556,14.6666667 C20.4444444,14.6666667 21,15.2222222 21.1111111,15.3333333 L21.1111111,21 L23,21 L23,1 C23,0.444444444 22.5555556,0 22,0 L7.88888889,0 C7.33333333,0 6.88888889,0.444444444 6.88888889,1 Z M5,17.6666667 L1.88888889,17.6666667 L1.88888889,14.4444444 L5,14.4444444 L5,17.6666667 Z M5,13.1111111 L1.88888889,13.1111111 L1.88888889,9.77777778 L5,9.77777778 L5,13.1111111 Z M8.66666667,2.11111111 L11.7777778,2.11111111 L11.7777778,5.33333333 L8.66666667,5.33333333 L8.66666667,2.11111111 Z M8.66666667,6.55555556 L11.7777778,6.55555556 L11.7777778,9.77777778 L8.66666667,9.77777778 L8.66666667,6.55555556 Z M11.8888889,14.3333333 L8.77777778,14.3333333 L8.77777778,11 L11.8888889,11 L11.8888889,14.3333333 Z M16.4444444,9.77777778 L13.3333333,9.77777778 L13.3333333,6.55555556 L16.4444444,6.55555556 L16.4444444,9.77777778 Z M16.4444444,5.33333333 L13.3333333,5.33333333 L13.3333333,2.11111111 L16.4444444,2.11111111 L16.4444444,5.33333333 Z M21.1111111,9.77777778 L18,9.77777778 L18,6.55555556 L21.1111111,6.55555556 L21.1111111,9.77777778 Z M21.1111111,5.33333333 L18,5.33333333 L18,2.11111111 L21.1111111,2.11111111 L21.1111111,5.33333333 Z",
  id: "path-1"
})));

function SvgOrganizationAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Organization Avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationAvatar);
export default __webpack_public_path__ + "static/media/organization_avatar.5cff21c7.svg";
export { ForwardRef as ReactComponent };